import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Router, Route, Switch } from 'react-router-dom'

import { ToastProvider } from 'react-toast-notifications'
import { IntlProvider } from 'react-redux-multilingual'
import { StylesProvider, ThemeProvider, jssPreset } from '@material-ui/styles'
import { createTheme } from '@material-ui/core/styles'
import { create } from 'jss'
import rtl from 'jss-rtl'
import { PageLoader } from './components'
import { alertActions } from './store/actions'

import {
	Error,
	Cart,
	Shop,
	Home,
	MobileProductDetail,
	AboutUs,
	PrivacyPolicy,
	Status,
} from './containers'
import {
	APP_HELPER,
	CONSTANTS,
	HELPER,
	HISTORY,
	LANG_TRANS,
	LocalStorageService,
	ROUTE_CONSTANTS,
} from './utils'
import ProtectedRoute from '../src/utils/routes/ProtectedRoute'

const jss = create({ plugins: [...jssPreset().plugins, rtl()] })
const ltrTheme = createTheme({ direction: CONSTANTS.LANG_DIRECTION.LTR })
const rtlTheme = createTheme({ direction: CONSTANTS.LANG_DIRECTION.RTL })

/*
  TAG MANAGER ARGUMENTS
*/
const DEFAULT_GTM_ID = process.env.REACT_APP_DEFAULT_GTM_ID

const hostname = window.location.hostname
function App() {
	let dispatch = useDispatch()
	const { locale } = useSelector((state) => state.Intl)
	const { gtm_id, theme_color } = useSelector((state) => state.config.merchant)

	// useEffect(() => {
	//   SEGMENT_ANALYTICS_HELPER._callSegment(process.env.REACT_APP_SEGMENT_ANALYTIC)
	// }, []);

	useEffect(() => {
		// store.dispatch(configActions.SET_DEFAULT_APP_STATE());
		/*
      		INITIALIZE APPLICATION
        */
		LocalStorageService._clearLocalStorage()
		LocalStorageService._clearSessionStorage()
		LocalStorageService._removeCatalogURL()

		/*
		  INITIALIZE TAG MANAGER WITH DEFAULT TAG ID
		*/
		APP_HELPER.SET_TAG_MANAGER(DEFAULT_GTM_ID)

		/*
		  INITIALIZE APP THEME COLOR
		*/
		if (!HELPER.isEmpty(theme_color)) {
			APP_HELPER.SET_COLOR_THEME(theme_color)
		}
		//clear all alert messages
		dispatch(alertActions.clear())

		// returned function will be called on component unmount
		return () => {}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		/*
		  UPDATE TAG MANAGER AND REINITIALIZE WITH MERCHANT'S GTM ID
		*/
		if (!HELPER.isEmpty(gtm_id) && DEFAULT_GTM_ID !== gtm_id) {
			APP_HELPER.SET_TAG_MANAGER(gtm_id)
		}
		/*
		  UPDATE APP THEME COLOR - W.R.T. MERCHANT SETTINGS
		*/
		if (!HELPER.isEmpty(theme_color)) {
			APP_HELPER.SET_COLOR_THEME(theme_color)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [gtm_id, theme_color])

	return (
		<>
			<PageLoader />
			<ToastProvider>
				<StylesProvider jss={jss}>
					<ThemeProvider
						theme={
							APP_HELPER.GET_LANG_DIRECTION() === CONSTANTS.LANG_DIRECTION.RTL ? rtlTheme : ltrTheme
						}
					>
						<IntlProvider
							translations={LANG_TRANS}
							locale={locale}
							defaultLocale={CONSTANTS.IS_ENGLISH}
						>
							<Router history={HISTORY} forceRefresh={true}>
								<Switch>
									<Route
										key={1}
										path={ROUTE_CONSTANTS.ERROR_PAGE}
										view={'Error'}
										component={Error}
										exact
									/>
									<Route
										key={7}
										path={ROUTE_CONSTANTS.STATUS}
										view={'Status'}
										component={Status}
										exact
									/>
									<Route key={2} path={ROUTE_CONSTANTS.CART} view={'Cart'} component={Cart} exact />
									<Route
										key={6}
										path={ROUTE_CONSTANTS.ABOUT_US}
										view={'About Us'}
										component={AboutUs}
										exact
									/>
									<Route
										key={6}
										path={ROUTE_CONSTANTS.PRIVACY_POLICY}
										view={'Privacy Policy'}
										component={PrivacyPolicy}
										exact
									/>
									{hostname.match(process.env.REACT_APP_DOMAIN_URL) ? (
										<ProtectedRoute
											key={3}
											path={ROUTE_CONSTANTS.BASE}
											view={'View All Marketplace Sellers'}
											component={Home}
											exact
										/>
									) : (
										<ProtectedRoute
											key={3}
											path={ROUTE_CONSTANTS.BSECURE_MALL}
											view={'View All Marketplace Sellers'}
											component={Home}
											exact
										/>
									)}
									<ProtectedRoute
										key={4}
										path={ROUTE_CONSTANTS.PRODUCT_DETAIL}
										view={'Product Detail'}
										component={MobileProductDetail}
										exact
									/>
									<ProtectedRoute key={5} view={'Shop'} component={Shop} />
								</Switch>
							</Router>
						</IntlProvider>
					</ThemeProvider>
				</StylesProvider>
			</ToastProvider>
		</>
	)
}

export default App
